'use strict';

var React = require('react');
var lighthouseFramework = require('@workforcesoftware/lighthouse-framework');
var lighthouseComponentLibrary = require('@workforcesoftware/lighthouse-component-library');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
var polished = require('polished');
var styledComponents = require('styled-components');
var reactRedux = require('react-redux');
var tsEnumUtil = require('ts-enum-util');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var frameworkI18n;
var setFrameworkI18n = function (i18n) {
    frameworkI18n = i18n;
};
var translate = function (key, substitutions) {
    return frameworkI18n.translate(key, substitutions);
};

var CUSTOM_LINKS = {
	TITLE: {
		TARGET: "Links",
		NOTE: "The title of the Custom Links hub card. It displays in Title case and has the meaning of the plural form of the word Link (as a link to a website)."
	},
	NO_DATA: {
		TARGET: "There are no links to show",
		NOTE: "Message displayed in the body of the Custom Links hub card when there is no data available to show. The message is in sentence case."
	},
	LOADING: {
		TARGET: "Loading...",
		NOTE: "Message displayed in the body of the Custom Links hub card when the user needs to wait for the content to load. The message is in sentence case."
	},
	ERROR_MSG: {
		TARGET: "There is a problem getting the information.",
		NOTE: "Message displayed in the body of the Custom Links hub card when there is an error retrieving data. The message is in sentence case."
	}
};
var EnglishUS = {
	CUSTOM_LINKS: CUSTOM_LINKS
};

var RouteIds;
(function (RouteIds) {
    RouteIds["CustomLinksCard"] = "customLinksCard";
    RouteIds["TimesheetApproval"] = "timesheetApproval";
})(RouteIds || (RouteIds = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var CustomLinksCardIds;
(function (CustomLinksCardIds) {
    CustomLinksCardIds["CustomLinksCard"] = "navigation/customLinksCard";
})(CustomLinksCardIds || (CustomLinksCardIds = {}));

// Constant which will check the start of an external url
var CHECK_PREFIX_OF_EXTERNAL_LINKS = /^https|http|www|ftp?:\/\//i;
// Constant which will check the start of an internal url
var CHECK_START_OF_INTERNAL_LINKS = /^\/?workforce/i;
// Function which will check if the given url is external or internal link
function isExternalLink(url) {
    return (!CHECK_PREFIX_OF_EXTERNAL_LINKS.test(url));
}
// The function removes the /workforce prefix for backward compatibility
function nomralizeInternalLink(url) {
    return (CHECK_START_OF_INTERNAL_LINKS.test(url) ? url.replace(CHECK_START_OF_INTERNAL_LINKS, '') : url);
}
// Function which will check if the given url has a prefix 'www'. If yes then append 'http://' as a prefix.
function checkLinkStartWithWWW(url) {
    return (url.startsWith('www') ? "http://" + url : url);
}
// Opens the link in another browser when running on mobile.
function openLinkInSystemBrowser(url) {
    window.open(url, '_system');
}
// Default functionality for opening a link in a new tab. Used for web.
function openLinkInNewTab(url) {
    window.open(url, '_blank');
}
// Opens the link using a method appropriate for the current platform.
function openLink(url) {
    if (lighthouseFramework.isMobileDevice()) {
        openLinkInSystemBrowser(url);
    }
    else {
        openLinkInNewTab(url);
    }
}
var CustomLinksComponentItem = function (_a) {
    var label = _a.label, url = _a.url;
    return (React__namespace.createElement(CustomLinkStyledComponentItem, null,
        React__namespace.createElement(CustomStyledLink, { onClick: handleCustomLinkClick, "data-qa": "custom-link", href: "javascript:void(0)" }, label)));
    function handleCustomLinkClick() {
        if (!isExternalLink(url)) {
            openLink(checkLinkStartWithWWW(url));
        }
        else {
            openLink(lighthouseFramework.getWTAURL(nomralizeInternalLink(url)));
        }
    }
};
var CustomLinkStyledComponentItem = lighthouseComponentLibrary.styled.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n && {\n    display: flex;\n    justify-content: flex-start;\n    padding: ", " ", " ", " ", ";\n  }\n"], ["\n && {\n    display: flex;\n    justify-content: flex-start;\n    padding: ", " ", " ", " ", ";\n  }\n"])), polished.rem('16px'), polished.rem('0px'), polished.rem('0px'), polished.rem('0px'));
var CustomStyledLink = lighthouseComponentLibrary.styled.a(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  && {\n    margin-right: ", "\n    font-weight:normal\n    min-width: ", "\n    padding: ", ";\n    color: ", ";\n    text-decoration: none;\n     &:hover {\n       background-color: transparent;\n       border-color: transparent;\n       text-decoration: underline #067eb0;\n       cursor: pointer;\n     }\n  }\n"], ["\n  && {\n    margin-right: ", "\n    font-weight:normal\n    min-width: ", "\n    padding: ", ";\n    color: ", ";\n    text-decoration: none;\n     &:hover {\n       background-color: transparent;\n       border-color: transparent;\n       text-decoration: underline #067eb0;\n       cursor: pointer;\n     }\n  }\n"])), polished.rem('0px'), polished.rem('0px'), polished.rem('0px'), lighthouseComponentLibrary.getColor("primary", { shade: "main" }));
var templateObject_1$2, templateObject_2$1;

function CustomLinksCardBody(_a) {
    var customLinksData = _a.customLinksData, dataQa = _a["data-qa"];
    return (React__namespace.createElement(CustomLinksCardStyledBody, { "data-qa": dataQa }, customLinksData ?
        customLinksData
            .sort(function (customLink1, customLink2) {
            return (customLink1.sortOrder === customLink2.sortOrder) ?
                customLink1.label.localeCompare(customLink2.label)
                :
                    customLink1.sortOrder - customLink2.sortOrder;
        })
            .map(function (customLink, index) { return (React__namespace.createElement(React__namespace.Fragment, { key: index },
            React__namespace.createElement(CustomLinksComponentItem, { label: customLink.label, url: customLink.url }))); }) : ''));
}
var CustomLinksCardStyledBody = lighthouseComponentLibrary.styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  && {\n    padding: ", ";\n  }\n"], ["\n  && {\n    padding: ", ";\n  }\n"])), polished.rem('0px'));
var templateObject_1$1;

var HubCardMessageComponentWrapper = lighthouseComponentLibrary.styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", " ", " ", " ", ";\n"], ["\n    padding: ", " ", " ", " ", ";\n"])), polished.rem('12px'), polished.rem('12px'), polished.rem('40px'), polished.rem('12px'));
var HubCardErrorMessageComponentWrapper = lighthouseComponentLibrary.styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n   padding: ", " ", " ", " ", ";\n"], ["\n   padding: ", " ", " ", " ", ";\n"])), polished.rem('12px'), polished.rem('12px'), polished.rem('0px'), polished.rem('12px'));
var CustomLinksCard$1 = /** @class */ (function (_super) {
    __extends(CustomLinksCard, _super);
    function CustomLinksCard(props) {
        var _this = _super.call(this, props) || this;
        _this.render = function () {
            var customLinksData = _this.props.customLinksData || [];
            var onDelete = function (framework) { return function () {
                framework.removeHubCard(CustomLinksCardIds.CustomLinksCard, CustomLinksCardIds.CustomLinksCard, translate('CUSTOM_LINKS.TITLE'));
            }; };
            var componentToShow;
            if (_this.state.isDataLoaded) {
                componentToShow = (React__namespace.createElement(StyledCardContend, { "data-qa": "custom-links-card-content" }, !!customLinksData ? _this.getComponentToShow(customLinksData) :
                    componentToShow = _this.CustomLinksErrorComponent()));
            }
            else {
                componentToShow = _this.CustomLinksLoadingComponent();
            }
            return (React__namespace.createElement(lighthouseComponentLibrary.Card, { "data-qa": "custom-links-card" },
                React__namespace.createElement(lighthouseFramework.FrameworkContext.Consumer, null, function (framework) {
                    return (React__namespace.createElement(lighthouseComponentLibrary.CardHeader, { "data-qa": "custom-links-card-title", title: translate('CUSTOM_LINKS.TITLE'), icon: (React__namespace.createElement(lighthouseComponentLibrary.CardIcon, null,
                            React__namespace.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faLink }))), onDelete: onDelete(framework) }));
                }),
                componentToShow));
        };
        _this.CustomLinksLoadingComponent = function () {
            return (React__namespace.createElement(HubCardMessageComponentWrapper, { "data-qa": "custom-links-loading-card" },
                React__namespace.createElement(lighthouseComponentLibrary.Typography, { use: "body" }, translate('CUSTOM_LINKS.LOADING'))));
        };
        _this.CustomLinksEmptyCollectionComponent = function () {
            return (React__namespace.createElement(HubCardMessageComponentWrapper, { "data-qa": "custom-links-info-card" },
                React__namespace.createElement(lighthouseComponentLibrary.Typography, { use: "body" }, translate('CUSTOM_LINKS.NO_DATA'))));
        };
        _this.CustomLinksErrorComponent = function () {
            return (React__namespace.createElement(HubCardErrorMessageComponentWrapper, { "data-qa": "custom-links-error-card" },
                React__namespace.createElement(lighthouseComponentLibrary.Typography, { use: "body" }, translate('CUSTOM_LINKS.ERROR_MSG'))));
        };
        _this.state = {
            isDataLoaded: false
        };
        return _this;
    }
    CustomLinksCard.prototype.componentDidMount = function () {
        var _this = this;
        this.props.loadCustomLinks().then(function () {
            _this.setState({
                isDataLoaded: true
            });
        });
    };
    CustomLinksCard.prototype.getComponentToShow = function (customLinks) {
        var componentToShow = [];
        if (customLinks.length === 0) {
            return this.CustomLinksEmptyCollectionComponent();
        }
        componentToShow.push(React__namespace.createElement(CustomLinksCardBody, { "data-qa": "custom-links-loading-data", customLinksData: customLinks }));
        return componentToShow;
    };
    return CustomLinksCard;
}(React__namespace.Component));
var StyledCardContend = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.CardContent)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n && {\n    padding: ", "\n  }\n"], ["\n && {\n    padding: ", "\n  }\n"])), polished.rem('0px'));
var templateObject_1, templateObject_2, templateObject_3;

/**
 * Constants used in custom links hub card
 */
var NAVIGATION_SERVICE_NAME = 'navigation-service';

var loadCustomLinksCollection = "query getCustomLinks{\n  getCustomLinks{\n    label\n    sortOrder\n    url\n  }\n}";

var CustomLinkActionTypes;
(function (CustomLinkActionTypes) {
    CustomLinkActionTypes["LoadCustomLinks"] = "customLinks/loadCustomLinks";
})(CustomLinkActionTypes || (CustomLinkActionTypes = {}));

function loadCustomLinks(graphqlServiceFactory) {
    return function (dispatch) {
        var actionType = CustomLinkActionTypes.LoadCustomLinks;
        return graphqlServiceFactory
            .getGraphQlObject(NAVIGATION_SERVICE_NAME)
            .query(loadCustomLinksCollection, {})
            .then(function (result) {
            var action = {
                type: actionType,
                customLinksData: convertGraphqlResultToCustomLinkData(result.data.getCustomLinks)
            };
            dispatch(action);
        })
            .catch(function (error) {
            global.console.error('Error occurred while fetching custom links', error);
        });
    };
}
/**
 * Convert graphql to CustomLinkData object.
 */
var convertGraphqlResultToCustomLinkData = function (customLinksData) {
    var convertedCustomLinksData = customLinksData.map(function (customLink) {
        return {
            label: customLink.label,
            sortOrder: customLink.sortOrder,
            url: customLink.url
        };
    });
    return convertedCustomLinksData;
};

var mapStateToProps = function (state) {
    return {
        customLinksData: state.customLinksState.customLinksData
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        loadCustomLinks: function () {
            return dispatch(loadCustomLinks(lighthouseFramework.graphqlServiceFactory));
        }
    };
};
var CustomLinksCard = reactRedux.connect(mapStateToProps, mapDispatchToProps)(styledComponents.withTheme(CustomLinksCard$1));

var routes = function () {
    return [
        {
            id: RouteIds.CustomLinksCard,
            route: '/CustomLinksCard',
            component: CustomLinksCard,
            restricted: true
        }
    ];
};

var createCard = function (specs, editMode, changeHubCardConfig) {
    var hub = { editMode: editMode, changeHubCardConfig: changeHubCardConfig };
    switch (specs.getId()) {
        case CustomLinksCardIds.CustomLinksCard:
            return (React__namespace.createElement(CustomLinksCard, __assign({}, specs, hub)));
        default:
            throw new Error("Unsupported item id: " + specs.getId());
    }
};

var isCustomLinksFeatureFlagEnabledPropertyName = 'custom_links';

var _a;
var customLinksCard = {
    getId: function () { return CustomLinksCardIds.CustomLinksCard; },
    getName: function () { return translate('CUSTOM_LINKS.TITLE'); },
    getConfig: function () { return ({}); }
};
var hubCards = (_a = {},
    _a[CustomLinksCardIds.CustomLinksCard] = customLinksCard,
    _a);
var getConfigurationCard = function (cardId) {
    return hubCards[cardId];
};

var framework;
var getFrameworkInstance = function () { return framework; };
var setFrameworkInstance = function (lighthouseFramework) {
    framework = lighthouseFramework;
};

/**
 * Check if the card should appear for the user
 * @param cardId ID of the card which we want to check if it should appear
 */
var hubCardShouldAppear = function (cardId) {
    var _a;
    var featureFlag = getFrameworkInstance().getNamedFeatureFlags(isCustomLinksFeatureFlagEnabledPropertyName);
    return tsEnumUtil.$enum.visitValue(cardId).with((_a = {},
        _a[CustomLinksCardIds.CustomLinksCard] = function () {
            return Promise.resolve(featureFlag.custom_links);
        },
        _a[tsEnumUtil.$enum.handleUnexpected] = function () {
            global.console.error('Could not find the custom links card ', cardId);
            return Promise.resolve(false);
        },
        _a));
};
/**
 * Using Promise.all() to wait for all the promises to complete execution
 * before returning the hub cards.
 * @return Promise<HubCard[]> hub cards on which user has rights.
 */
function getHubCards() {
    var promises = tsEnumUtil.$enum(CustomLinksCardIds).map(function (cardId) {
        return hubCardShouldAppear(cardId)
            .then(function (result) {
            return result ? getConfigurationCard(cardId) : undefined;
        });
    });
    return Promise.all(promises).then(function (result) { return result.filter(function (value) { return !!value; }); });
}

var initialState = {
    customLinksData: []
};
var customLinksReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case CustomLinkActionTypes.LoadCustomLinks: {
            return __assign(__assign({}, state), { customLinksData: action.customLinksData });
        }
    }
    return state;
};

var hubCardFactory = {
    create: function (card, editMode, changeHubCardConfig) {
        return createCard(card, editMode, changeHubCardConfig);
    },
    getCardSpecifications: getHubCards
};
var module$1 = {
    setFrameworkInstance: setFrameworkInstance,
    getId: function () { return 'navigation'; },
    getName: function () { return 'Navigation Module'; },
    getRouteSpecifications: function () { return routes(); },
    getReducers: function () { return ({
        customLinksState: customLinksReducer
    }); },
    setI18nInstance: function (instance) {
        setFrameworkI18n(instance);
    },
    getI18nResources: function () {
        return {
            'en-US': EnglishUS
        };
    },
    getHubCardFactory: function () {
        return hubCardFactory;
    }
};

exports.Module = module$1;
//# sourceMappingURL=index.js.map
